import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { withRenderToasters } from 'utils/hoc/withRenderToasters'

import {
  isAccountTypeBrand,
  isAddStylesWhenShipBeforeLinesheetShipRestricted,
} from 'store/currentUser/selectors'
import {
  setCollectionId,
  setSearchText,
} from 'store/shop/addMoreProductsModal/actions'
import {
  getCollectionId,
  getSearchText,
} from 'store/shop/addMoreProductsModal/selectors'

import AddMoreProductsModal from 'modals/OrderReview/AddMoreProductsModal/AddMoreProductsModal.component'
import withUpsertOrderQuantities from 'modals/OrderReview/AddMoreProductsModal/AddMoreProductsModal.mutations'
import withCollectionsFormatter from 'modals/OrderReview/AddMoreProductsModal/AddMoreProductsModalCollections.formatter'
import withProductsFormatter from 'modals/OrderReview/AddMoreProductsModal/AddMoreProductsModalProducts.formatter'
import { withOrderCommonInfo } from 'modals/OrderReview/AddMoreProductsModal/withOrderCommonInfo.hoc'

const mapStateToProps = (state: any, ownProps: any) => ({
  isBrandAccount: isAccountTypeBrand(state),
  orderIds: [ownProps.orderId],
  selectedCollectionId: getCollectionId(state),
  searchText: getSearchText(state),
  permissions: {
    isAddStylesWhenShipBeforeLinesheetShipRestricted:
      isAddStylesWhenShipBeforeLinesheetShipRestricted(state),
  },
})

const mapDispatchToProps = {
  setCollectionId,
  setSearchText,
}
const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  // TODO(sc154400): use new mutation
  withUpsertOrderQuantities,
  withOrderCommonInfo,
  withCollectionsFormatter,
  withProductsFormatter,
  withRenderToasters,
)(AddMoreProductsModal)
